import { render, staticRenderFns } from "./EditProfileServices.vue?vue&type=template&id=b61c50ac"
import script from "./EditProfileServices.vue?vue&type=script&lang=js"
export * from "./EditProfileServices.vue?vue&type=script&lang=js"
import style0 from "./EditProfileServices.vue?vue&type=style&index=0&id=b61c50ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports